import React, { Fragment, useEffect } from 'react'
import weatherApp3 from '../../assets/images/weatherApp3.png'
import TheStraighteningTest from '../../assets/images/TheStraighteningTest.png'
import SafeSets from '../../assets/images/SafeSets.png'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faJs,
  faHtml5,
  faCss3Alt,
  faReact,
  faMicrosoft,
} from '@fortawesome/free-brands-svg-icons'
import { faDatabase, faServer } from '@fortawesome/free-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

function Projects() {
  useEffect(() => {
    AOS.init({
      disable: window.innerWidth < 768,
    })
  }, [])

  const projects = [
    {
      image: weatherApp3,
      title: 'Weather App',
      description:
        'A React application providing real-time weather forecasts with beautiful visualizations. Uses geolocation API and OpenWeather services for accurate data.',
      techs: [
        { icon: faJs, label: 'JavaScript' },
        { icon: faReact, label: 'React' },
        { icon: faHtml5, label: 'HTML' },
        { icon: faCss3Alt, label: 'CSS' },
      ],
      //url: 'https://fredcoder.github.io/weather/',
    },
    {
      image: TheStraighteningTest,
      title: 'The Straightening Test',
      description:
        'An interactive game developed for Orthodontics Australia to test users ability to identify straightness of images in a fun, engaging way.',
      techs: [
        { icon: faJs, label: 'JavaScript' },
        { icon: faReact, label: 'React' },
        { icon: faHtml5, label: 'HTML' },
        { icon: faCss3Alt, label: 'CSS' },
      ],
      //url: 'https://thestraighteningtest.com/',
    },
    {
      image: SafeSets,
      title: 'SafeSets',
      description:
        'A comprehensive web solution for tracking health and safety information for the film industry. Monitor work locations, team members, and sanitation protocols.',
      techs: [
        { icon: faDatabase, label: 'SQL' },
        { icon: faMicrosoft, label: '.NET' },
        { icon: faServer, label: 'Web API' },
        { icon: faReact, label: 'React' },
      ],
      url: '',
    },
  ]

  return (
    <section className="projects" id="projects">
      <div className="projects-container">
        <div className="section-header">
          <span className="section-tag">My Work</span>
          <h2 className="section-title">Featured Projects</h2>
          <div className="section-line"></div>
        </div>

        <div className="projects-grid">
          {projects.map((project, idx) => (
            <Fragment key={project.title}>
              <div
                className="project-card"
                data-aos={idx % 2 === 0 ? 'fade-right' : 'fade-left'}
              >
                <div className="project-image-wrapper">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="project-image"
                  />
                  <div className="project-overlay"></div>
                </div>
                <div className="project-content">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="project-techs">
                    {project.techs.map((tech) => (
                      <span key={tech.label} className="project-tech">
                        <FontAwesomeIcon icon={tech.icon as IconProp} />
                        {tech.label}
                      </span>
                    ))}
                  </div>
                  {project.url && (
                    <a
                      href={project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="project-link"
                    >
                      View Live
                    </a>
                  )}
                </div>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Projects
